<h1 mat-dialog-title>{{ 'properties.home.privacyDocsDialog.title' | translate }}</h1>
<mat-dialog-content class="privacy-docs-list">
  <div class="privacy-doc-row" *ngFor="let row of rows">
    <button
      mat-flat-button
      type="button"
      [color]="row.action === 'generate' ? 'accent' : 'warn'"
      class="privacy-doc-btn"
      [disabled]="!row.enabled || row.loading"
      matTooltip="{{ !row.enabled ? ('properties.home.privacyDocsDialog.comingSoon' | translate) : '' }}"
      (click)="onRowAction(row)">
      <mat-spinner *ngIf="row.loading" strokeWidth="2" [diameter]="16" class="d-inline-block"></mat-spinner>
      <span *ngIf="!row.loading">
        {{ (row.action === 'generate' ? 'properties.home.privacyDocsDialog.generate' : 'properties.home.privacyDocsDialog.download') | translate }}
      </span>
    </button>
    <span class="privacy-doc-label">{{ row.labelKey | translate }}</span>
  </div>
</mat-dialog-content>
<div class="row" mat-dialog-actions>
  <div class="col-12 text-right">
    <button mat-raised-button (click)="onClose()">
      {{ 'common.cta.close' | translate }}
    </button>
  </div>
</div>
